export const ASYNC_STORAGE_KEYS = {
    CONTINUE_DOWNLOAD: 'continue_download',
    DOWNLOAD_IN_PROGRESS_STORES: 'download_in_progress_stores',
    DOWNLOAD_IN_PROGRESS_STORES_STARTED_AT: 'download_in_progress_stores_started_at',
    DOWNLOAD_IN_PROGRESS_SCHEDULE_POS: 'download_in_progress_schedule_pos',
    DOWNLOAD_IN_PROGRESS_SCHEDULE_POS_STARTED_AT:
        'download_in_progress_schedule_pos_started_at',
    DOWNLOAD_IN_PROGRESS_PERFECT_STORES: 'download_in_progress_perfect_stores',
    DOWNLOAD_IN_PROGRESS_ASSETS_PERFECT_STORES: 'download_in_progress_assets_perfect_stores',
    IS_USER_CONTENT_ZIP: 'is_user_content_zip',
    STOP_PROCESS_SCHEDULE: 'stop_process_schedule',
    IS_USER_CONTENT_ZIP_PS: 'is_user_content_zip_ps',
    UNZIP_IN_PROGRESS_PS: 'unzip_in_progress_ps',
    SAVE_PS_FORMS: 'save_ps_forms',
    PS_ZIP_ALL_SAVED: 'ps_zip_all_saved',
    PS_ASSETS_ALL_SAVED: 'ps_assets_all_saved_v2',
    // Terms & Conditions accepted cache (per course and version): `${TERMS_AND_CONDITIONS_ACCEPTED}:<courseId>:<version>` -> 'true'
    TERMS_AND_CONDITIONS_ACCEPTED: 'terms_and_conditions_accepted',
    // Cache último TTCC descargado (para mostrar offline)
    TERMS_AND_CONDITIONS_LAST: 'terms_and_conditions_last', // por curso: `${TERMS_AND_CONDITIONS_LAST}:<courseId>` -> JSON { version, terms }
    TERMS_AND_CONDITIONS_LAST_GLOBAL: 'terms_and_conditions_last_global', // global -> JSON { version, terms }
    HAS_STORES_ZIP: 'has_stores_zip',
}
